import StripHtml from '@/core/directives/strip-html.directive';
import { DateFormatter, DateTimeFormatter, FontColorContraster, OutsideClickDirective, PhoneFormatter } from '@nxtpeople/nxt-vue-library';
import { App } from 'vue';
import { buildVueDompurifyHTMLDirective } from 'vue-dompurify-html';
import { AddressFormatter } from '../directives/address-formatter.directive';

const vPurifyHtml = buildVueDompurifyHTMLDirective();

function setupDirectives(app: App<Element>) {
   app.directive('purify-html', vPurifyHtml);
   app.directive('outside-click', OutsideClickDirective);
   app.directive('strip-html', StripHtml);
   app.directive('font-color-contrast', FontColorContraster);
   app.directive('date', DateFormatter);
   app.directive('date-time', DateTimeFormatter);
   app.directive('phone', PhoneFormatter);
   app.directive('address', AddressFormatter);
}

export { setupDirectives };
